import Treeize from './treeize';

const surveyT = new Treeize();
const testData = [
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 123,
    'questions:SurveyQuestionName': 'Ice Cream Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 318,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Strongly Approve',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=3',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 123,
    'questions:SurveyQuestionName': 'Ice Cream Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 319,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Somewhat Approve',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=3',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 123,
    'questions:SurveyQuestionName': 'Ice Cream Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 320,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Somewhat Disapprove',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=9',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 123,
    'questions:SurveyQuestionName': 'Ice Cream Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 321,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Strongly Disapprove',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=9',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 123,
    'questions:SurveyQuestionName': 'Ice Cream Approval',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you approve or disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 322,
    'questions:answers:digit': '5',
    'questions:answers:value': 'Undecided',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=2',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 124,
    'questions:SurveyQuestionName': 'Ice Cream Approval - Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Okay, but if you had to choose, would you say you generally approve of, or generally disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 323,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Generally Approve',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=3',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 124,
    'questions:SurveyQuestionName': 'Ice Cream Approval - Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Okay, but if you had to choose, would you say you generally approve of, or generally disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 324,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Generally Disapprove',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=9',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 124,
    'questions:SurveyQuestionName': 'Ice Cream Approval - Push',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Okay, but if you had to choose, would you say you generally approve of, or generally disapprove of Ice Cream? ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 325,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Completely Undecided',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'BYE',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 125,
    'questions:SurveyQuestionName': 'Consumption Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'How do you most enjoy Ice Cream?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 326,
    'questions:answers:digit': '1',
    'questions:answers:value': 'In A Bowl',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 125,
    'questions:SurveyQuestionName': 'Consumption Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'How do you most enjoy Ice Cream?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 327,
    'questions:answers:digit': '2',
    'questions:answers:value': 'On A Cone',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=4',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 125,
    'questions:SurveyQuestionName': 'Consumption Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'How do you most enjoy Ice Cream?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 328,
    'questions:answers:digit': '3',
    'questions:answers:value': 'On A Stick',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=8',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 125,
    'questions:SurveyQuestionName': 'Consumption Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'How do you most enjoy Ice Cream?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 329,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Between Two Cookies',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=5',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 126,
    'questions:SurveyQuestionName': 'Cone Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you prefer Ice Cream on a sugar cone, a waffle cone, or a cake cone?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 330,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Sugar',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 126,
    'questions:SurveyQuestionName': 'Cone Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you prefer Ice Cream on a sugar cone, a waffle cone, or a cake cone?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 331,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Waffle',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 126,
    'questions:SurveyQuestionName': 'Cone Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you prefer Ice Cream on a sugar cone, a waffle cone, or a cake cone?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 332,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Cake',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 126,
    'questions:SurveyQuestionName': 'Cone Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Do you prefer Ice Cream on a sugar cone, a waffle cone, or a cake cone?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 333,
    'questions:answers:digit': '4',
    'questions:answers:value': 'Doesn\'t Matter',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 127,
    'questions:SurveyQuestionName': 'Sandwich Cookie Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'What kind of cookies do you prefer Ice Cream sandwiched between?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 334,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Chocolate Chip',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 127,
    'questions:SurveyQuestionName': 'Sandwich Cookie Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'What kind of cookies do you prefer Ice Cream sandwiched between?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 335,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Oatmeal',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 128,
    'questions:SurveyQuestionName': 'Ice Cream Flavor Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '7',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '7',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'What flavor of Ice Cream do you prefer?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 337,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Chocolate',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=7',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 128,
    'questions:SurveyQuestionName': 'Ice Cream Flavor Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '7',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '7',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'What flavor of Ice Cream do you prefer?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 338,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Black Raspberry',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=7',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 128,
    'questions:SurveyQuestionName': 'Ice Cream Flavor Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '7',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '7',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'What flavor of Ice Cream do you prefer?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 339,
    'questions:answers:digit': '3',
    'questions:answers:value': 'Other',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=10',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 128,
    'questions:SurveyQuestionName': 'Ice Cream Flavor Preference',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '7',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '7',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'What flavor of Ice Cream do you prefer?',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 340,
    'questions:answers:digit': '4',
    'questions:answers:value': 'No Preference',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=7',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 129,
    'questions:SurveyQuestionName': 'Gender',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'For statistical purposes only, please select the gender you most closely identify with. ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 341,
    'questions:answers:digit': '1',
    'questions:answers:value': 'Female',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'BYE',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 129,
    'questions:SurveyQuestionName': 'Gender',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'For statistical purposes only, please select the gender you most closely identify with. ',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 342,
    'questions:answers:digit': '2',
    'questions:answers:value': 'Male',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'BYE',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 130,
    'questions:SurveyQuestionName': 'Stick Response',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '3',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '3',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Sorry. It seems you\'ve conflated Ice Cream and popsicles. Ice Cream does not come on sticks.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 344,
    'questions:answers:digit': '1',
    'questions:answers:value': 'OK',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=3',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 131,
    'questions:SurveyQuestionName': 'Disapprove Response',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'BYE',
    'questions:defaultActionValue': '',
    'questions:noAnswerReceivedAction': 'BYE',
    'questions:noAnswerReceivedValue': '',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'You do not seem to be human. Go away, Ice Cream hating robot!',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 343,
    'questions:answers:digit': '1',
    'questions:answers:value': 'OK',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'BYE',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
  {
    callId: 38,
    callName: 'UPenn Bootcamp Survey',
    active: 1,
    intro: 'Hello! Thank you for taking this Chocolate Cows survey. This is solely for research purposes, and your answers remain confidential. Click to begin.',
    endMessage: 'Okay, that’s all. Thank you very much for your time!',
    goal: 'Assess ice cream preference of UPenn LPS staff and alumni',
    'questions:surveyQuestionId*': 132,
    'questions:SurveyQuestionName': 'Flavor Response',
    'questions:recordingMp3S3': null,
    'questions:defaultAction': 'GOTO',
    'questions:defaultActionValue': '6',
    'questions:noAnswerReceivedAction': 'GOTO',
    'questions:noAnswerReceivedValue': '6',
    'questions:singleDigit': 1,
    'questions:multipleDigitQuestion': 0,
    'questions:numberOfDigits': 1,
    'questions:lowerLimit': null,
    'questions:upperLimit': null,
    'questions:required': 0,
    'questions:nameLong': 'Sorry, Weckerly\'s didn\'t have other flavors. Try again.',
    'questions:defaultResponseText': '',
    'questions:statement': 0,
    'questions:feedback': 0,
    'questions:answers:surveyQuestionAnswerId': 345,
    'questions:answers:digit': '1',
    'questions:answers:value': 'OK',
    'questions:answers:answerValue': '',
    'questions:answers:action': 'GOTO=6',
    'questions:answers:doNotRandomize': 0,
    'questions:answers:s3url': null,
    'questions:answers:responseText': '',
  },
];

const survey = { questions: surveyT.grow(testData).getData()[0].questions };
survey.intro = testData[0].intro;
survey.goal = testData[0].goal;
survey.endMessage = testData[0].endMessage;
export default survey;



// WEBPACK FOOTER //
// ./src/research/treeizeData.js